// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2af1798c","468":"0babd872"}[chunkId] + ".chunk.js";
};